import { CardContainerVariantType } from '../../../../../../components/cardContainer/types/cardContainer';
import { CardContainerState } from '../../../../../../components/cardContainer/types/state';
import { commonStandardContainerVariantStyles } from '../commonStyles/common';
export const getInteractiveStandardStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [CardContainerVariantType.INTERACTIVE_STANDARD]: {
            isInteractive: true,
            [CardContainerState.DEFAULT]: {
                container: {
                    ...commonStandardContainerVariantStyles(FOUNDATIONS, FONT),
                    background: FOUNDATIONS.color_comp_containers_bg,
                },
            },
            [CardContainerState.PRESSED]: {
                container: {
                    ...commonStandardContainerVariantStyles(FOUNDATIONS, FONT),
                    background: FOUNDATIONS.color_accent_pressed_primary_bg_200,
                },
            },
            [CardContainerState.HOVER]: {
                container: {
                    ...commonStandardContainerVariantStyles(FOUNDATIONS, FONT),
                    transform: 'scale(1.03)',
                    background: FOUNDATIONS.color_comp_containers_bg,
                    box_shadow: SHADOWS.shadow_50,
                },
            },
            [CardContainerState.DISABLED]: {
                container: {
                    ...commonStandardContainerVariantStyles(FOUNDATIONS, FONT),
                    background: FOUNDATIONS.color_accent_disabled_bg_200,
                },
            },
            [CardContainerState.FOCUSED]: {
                container: {
                    ...commonStandardContainerVariantStyles(FOUNDATIONS, FONT),
                    background: FOUNDATIONS.color_comp_containers_bg,
                    box_shadow: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.blur_00} ${FOUNDATIONS.spread_50} ${FOUNDATIONS.color_effect_focus_50}, ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_00} ${FOUNDATIONS.blur_00} ${FOUNDATIONS.spread_100} ${FOUNDATIONS.color_effect_focus_100}`,
                },
            },
        },
    };
};
//# sourceMappingURL=interactiveStandard.js.map